/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import "./confirmModal.css"; // Reuse existing modal styles

function TitleModal({ isOpen, onClose, onConfirm, initialTitle = "" }) {
  const [title, setTitle] = useState(initialTitle);

  useEffect(() => {
    setTitle(initialTitle);
  }, [initialTitle]);

  const handleSubmit = () => {
    const trimmedTitle = title.trim();
    if (trimmedTitle) {
      onConfirm(trimmedTitle);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    } else if (event.key === "Escape") {
      event.preventDefault();
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Save Library Item</h2>
        <div style={{ marginBottom: "1rem" }}>
          <label htmlFor="title-input" style={{ display: "block", marginBottom: "0.5rem", color: "var(--Grey6)" }}>
            Title:
          </label>
          <input
            id="title-input"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter title for library item"
            autoFocus
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid var(--Grey3)",
              backgroundColor: "var(--Grey2)",
              color: "var(--Grey6)",
              fontSize: "14px",
              boxSizing: "border-box",
            }}
          />
        </div>
        <div className="modal-buttons">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button 
            onClick={handleSubmit} 
            className="confirm-btn"
            disabled={!title.trim()}
            style={{
              backgroundColor: title.trim() ? "var(--Grey2)" : "var(--Grey3)",
              borderColor: title.trim() ? "var(--Blue2)" : "var(--Grey4)",
              color: title.trim() ? "var(--Blue2)" : "var(--Grey4)",
              cursor: title.trim() ? "pointer" : "not-allowed",
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default TitleModal;